<script>
	const optimizedResize = require('utilities/optimizedResize');
	const _ = require('underscore');

	module.exports = {
		data() {
			return {
				visible: false
			};
		},
		methods: {
			_debouncedScrollWatcher: _.debounce(function () {
				this.scrollWatcher();
			}, 25),
			scrollWatcher() {
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				const winHeight = window.innerHeight;

				this.visible = scrollTop > winHeight / 2;
			},
			onClick() {
				$('body, html').animate(
					{
						scrollTop: 0
					},
					100,
					this.scrollWatcher
				);
			}
		},
		mounted() {
			window.addEventListener('scroll', this._debouncedScrollWatcher, { passive: true });
			optimizedResize.add(this.scrollWatcher);

			this.scrollWatcher();
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this._debouncedScrollWatcher);
			optimizedResize.remove(this.scrollWatcher);
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';

	.snap-to-top {
		transition:
			opacity 0.4s ease,
			right 0.4s ease;
		position: fixed;
		opacity: 0;
		width: 38px;
		height: 38px;
		padding: 0;
		bottom: 6px;
		right: -38px;
		line-height: 38px;
		vertical-align: middle;
		cursor: pointer;
		border-radius: 4px;
		text-align: center;

		@include media(med) {
			bottom: 20px;
		}

		&.snap-to-top-visible {
			padding: 0;
			opacity: 1;
			right: 10px;

			@include media(med) {
				right: 20px;
			}
		}
	}
</style>
<template>
	<button
		:class="[
			'snap-to-top',
			'button',
			{
				'snap-to-top-visible': visible
			}
		]"
		aria-label="Scroll to top"
		@click="onClick">
		&#x25B2;
	</button>
</template>
